<template>
  <div>
    <BlocoFormularioCadastro voltar="/dominio" @salvar="salvar()">
      <template #form>
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="panel panel-primary">
              <div class="panel-heading">
                <h4>Informações gerais</h4>
              </div>
              <div class="panel-body">
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-10 col-lg-10">
                    <CampoNome
                      :label-sup="'(1)'"
                      :validacao="v$.dominio.nome"
                      :valor="dominio.nome"
                      :somente-leitura="!!dominio._id"
                      @atualizar="dominio.nome = $event"
                    >
                      <template #mensagensValidacao>
                        <span
                          v-if="!v$.dominio.nome.required"
                          class="help-block"
                        >
                          Campo é obrigatório.
                        </span>
                        <span
                          v-if="!v$.dominio.nome.minLength"
                          class="help-block"
                        >
                          Campo deve ter pelo menos
                          {{ v$.dominio.nome.$params.minLength.min }}
                          letras.
                        </span>
                      </template>
                    </CampoNome>
                  </div>
                  <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2">
                    <SelecionarSituacao
                      :label-sup="'(1)'"
                      :validacao="v$.dominio.ativo"
                      :valor="dominio.ativo"
                      :mostrar-todos="false"
                      @atualizar="dominio.ativo = $event"
                    >
                      <template #mensagensValidacao>
                        <span
                          v-if="!v$.dominio.ativo.required"
                          class="help-block"
                        >
                          Campo é obrigatório.
                        </span>
                      </template>
                    </SelecionarSituacao>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <CampoGenerico
                      id="nomeExibicao"
                      label="Nome Exibição"
                      :valor="dominio.nomeExibicao"
                      @atualizar="dominio.nomeExibicao = $event"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="panel panel-primary">
              <div class="panel-heading">
                <div class="row">
                  <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                    <h4>Valores</h4>
                  </div>
                  <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                    <div class="pull-right">
                      <div class="btn-group pull-right" role="group">
                        <div
                          v-if="valoresSelecionados.length"
                          class="btn-group btn-group-sm"
                          role="group"
                        >
                          <button
                            type="button"
                            class="btn btn-danger"
                            @click="aoRemoverValores"
                          >
                            <span class="fa fa-trash" />
                            Remover
                            {{ valoresSelecionados.length }} selecionados
                          </button>
                        </div>

                        <div class="btn-group btn-group-sm" role="group">
                          <button
                            type="button"
                            class="btn btn-success"
                            @click="dominio.valores.push({})"
                          >
                            <span class="fa fa-plus" />
                            Adicionar
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="panel-body">
                <div v-if="dominio.valores.length === 0" class="row">
                  <div class="well text-center" style="margin: 0 1rem">
                    <p>Não há valores cadastrados.</p>
                  </div>
                </div>
                <div v-else class="row">
                  <div
                    v-for="(valor, index) in dominio.valores"
                    :key="valor.id || index"
                    class="col-xs-12 col-sm-6 col-md-4 col-lg-4"
                    style="margin: 4px 0"
                  >
                    <div style="display: flex; align-items: center; gap: 4px">
                      <div class="checkbox">
                        <label>
                          <input
                            v-model="valoresSelecionados"
                            type="checkbox"
                            :value="index"
                          />
                        </label>
                      </div>
                      <input
                        v-model="valor.valor"
                        class="form-control"
                        type="text"
                        placeholder="Valor"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </BlocoFormularioCadastro>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { minLength, required } from '@vuelidate/validators'

import { useMenu } from '@/composables/useMenu'
import { cadastroMixin } from '@/mixins/CadastroMixin'
import router from '@/router'
import DominioServico from '@/servicos/DominioServico'
import MensagemServico from '@/servicos/MensagemServico'
import camelCase from '@/utils/camel-case'

const mensagemServico = new MensagemServico()
const dominioServico = new DominioServico()

export default {
  mixins: [cadastroMixin],
  setup() {
    useMenu(70)
    return { v$: useVuelidate() }
  },
  data() {
    return {
      servico: new DominioServico(),
      entidade: 'dominio',
      consulta: 'Dominio',
      valoresSelecionados: [],
      dominio: {
        nome: '',
        nomeExibicao: '',
        ativo: 'true',
        valores: [],
      },
    }
  },
  validations: {
    dominio: {
      nome: { required, minLength: minLength(3) },
      ativo: { required },
    },
  },
  methods: {
    gerarCodigosValores() {
      this.dominio.valores.forEach((v) => {
        if (v.codigo) return
        v.codigo = camelCase(v.valor)
      })
    },
    salvar() {
      this.v$.$touch()

      if (this.v$.dominio.$invalid) {
        mensagemServico.cadastroInvalido(this.v$)
      } else {
        this.dominio.valores = this.dominio.valores.filter(
          (v) => v.valor && v.valor.trim() !== ''
        )
        this.gerarCodigosValores(this.dominio.valores)
        this.dominio.ativo = this.dominio.ativo === 'true'

        if (this.dominio._id) {
          dominioServico
            .atualizar(this.dominio._id, this.dominio)
            .then((result) => {
              if (result.erro) {
                mensagemServico.alerta(result.erro.content, result.erro.title)
                return
              }

              router.replace({ name: 'Dominio' })
            })
        } else {
          dominioServico.criar(this.dominio).then((result) => {
            if (result.erro) {
              mensagemServico.alerta(result.erro.content, result.erro.title)
              return
            }

            router.replace({ name: 'Dominio' })
          })
        }
      }
    },
    aoRemoverValores() {
      this.dominio.valores = this.dominio.valores.filter(
        (v, index) => !~this.valoresSelecionados.indexOf(index)
      )
      this.valoresSelecionados = []
    },
  },
}
</script>
